// extracted by mini-css-extract-plugin
module.exports = {"body":"MenuBlock_body__3cthM"};